/**
 * Normalize activity type strings from the app/backend into canonical portal categories.
 *
 * The mobile app can emit user-facing labels such as "BGM Test" while portal charts
 * expect canonical keys like "bgm". Keep alias handling centralized here so chart,
 * timeline, and marker logic stay in sync.
 */

const ACTIVITY_TYPE_ALIASES: Record<string, string> = {
  feeding: 'food',
  meal: 'food',
  'water intake': 'water',
  waterintake: 'water',
  bgm: 'bgm',
  'bgm test': 'bgm',
  bgtest: 'bgm',
  'bg test': 'bgm',
  'blood glucose': 'bgm',
  'blood glucose monitoring': 'bgm',
  'blood glucose test': 'bgm',
  'glucose test': 'bgm',
  'glucose reading': 'bgm',
  // Medicine / medication: backend or mobile may emit either form;
  // canonicalize to 'medicine' so the dashboard panel + chart marker
  // styling agree on a single bucket key.
  medication: 'medicine',
}

const normalizeActivityTypeKey = (activityType?: string | null): string => {
  return (activityType || '').trim().toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ')
}

export const getCanonicalActivityType = (activityType?: string | null): string => {
  const normalized = normalizeActivityTypeKey(activityType)
  if (!normalized) return 'default'

  return ACTIVITY_TYPE_ALIASES[normalized] || normalized
}
